// use SITE_URL or VERCEL_URL server side, use empty clientside
export const BASE_URL = process.env.SITE_URL
  ? process.env.SITE_URL
  : process.env.VERCEL_URL
    ? `https://${process.env.VERCEL_URL}`
    : "";

// The app registers how to get a Firebase ID token (apps/web
// utils/firebaseAuth.ts, which loads the Firebase SDK on demand). Importing
// firebase/auth here put the whole SDK in every page's initial JS.
type IdTokenGetter = () => Promise<string | null | undefined>;
let idTokenGetter: IdTokenGetter | null = null;
export const setIdTokenGetter = (getter: IdTokenGetter) => {
  idTokenGetter = getter;
};

export const getAuthHeaders = async (): Promise<HeadersInit> => {
  let token;
  try {
    token = await idTokenGetter?.();
  } catch (e) {
    if (sessionStorage?.hasItem?.("authToken")) {
      token = sessionStorage.getItem("authToken");
    }
  }

  if (!token) return {};

  return {
    Authorization: `${token}`,
  };
};

export const getAuthBearerHeaders = async (): Promise<HeadersInit> => {
  const token = await idTokenGetter?.();

  if (!token) return {};

  return {
    Authorization: `Bearer ${token}`,
  };
};
